export default "__VITE_ASSET__DPEg$psl__"